"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAlert = void 0;
var EAlert;
(function (EAlert) {
    EAlert["INFO"] = "INFO";
    EAlert["DANGER"] = "DANGER";
    EAlert["SUCCESS"] = "SUCCESS";
    EAlert["WARNING"] = "WARNING";
    EAlert["DARK"] = "DARK";
    EAlert["LIGHT"] = "LIGHT";
})(EAlert || (exports.EAlert = EAlert = {}));
